import { api } from "#app/http/api";
import { User } from "#modules/users/infra/User.dto";

export const fetchTeam = async (): Promise<(User & { createdAt: string; updatedAt: string })[]> => {
  const response = await api.users.team.get.query();

  if (response.status === 200) {
    return response.body.map((user) => ({
      ...user,
      createdAt: user.createdAt as unknown as string,
      updatedAt: user.updatedAt as unknown as string,
    }));
  }

  return [];
};
